import { Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, Tbody, Td, Text, Tr, VStack } from "@chakra-ui/react";
import { colors } from "../../styles";

interface MarketingModalProps {
    isOpen: boolean;    
    onClose: () => void;
}

export default function MarketingModal(props: MarketingModalProps) {
    return (
        <Modal size="2xl" motionPreset="slideInBottom" scrollBehavior="inside" isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent maxH="90vh">
                <ModalHeader>
                    <Text fontSize={20} fontWeight={700} color={colors.black}>광고성 정보 수신 및 마케팅 활용 동의</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody padding={10}>

                    {/* 레이블 */}

                    <Text fontSize={16} fontWeight={700} color={colors.black}>
                        팜챗(PharmChat) 광고성 정보 수신 및 마케팅 활용 동의
                    </Text>

                    {/* 구분선 */}

                    <Divider marginY={5} />

                    {/* 내용 */}

                    <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                        주식회사 더리얼 (이하 “회사”) 은<br />
                        이용자에게 최적화된 맞춤형 정보를 제공하기 위해 아래와 같이 개인정보를 수집 및 이용합니다.<br />
                        본 동의는 선택 사항이며, 거부하더라도 팜챗의 기본 서비스 이용에는 제한이 없습니다.<br />
                    </Text>

                    {/* 개인정보 수집 및 이용 동의 내용 */}

                    <Table width="100%" fontSize={14} variant="simple" marginY={10}>
                        <Tbody>
                            <Tr>
                                <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                    수집 항목
                                </Td>
                                <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                    아이디, 성명, 이메일, 연락처(휴대폰 번호), 소속 정보(약국/학교/직능) 등
                                </Td>
                            </Tr>
                            <Tr>
                                <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                    처리 목적
                                </Td>
                                <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                1. 서비스 고도화: 이용 행태 분석을 통한 개인 맞춤형 기능 개발 및 특화<br />
                                2. 광고성 정보 전달: 이벤트, 프로모션, 제약 정보 등 광고성 정보 전달 (이메일, SMS, 카카오톡 알림톡 발송 등)<br />
                                3. 통계 분석: 접속 빈도 파악 및 회원 서비스 이용 통계 활용
                                </Td>
                            </Tr>
                            <Tr>
                                <Td border="1px" borderColor="gray.200" p={2} fontWeight={700} bg="gray.50" width="25%">
                                    보유 및 이용 기간
                                </Td>
                                <Td border="1px" borderColor="gray.200" p={2} width="75%">
                                    회원 탈퇴 시 또는 동의 철회 시까지 (단, 관련 법령에 따른 보존 의무가 있는 경우 해당 기간까지)
                                </Td>
                            </Tr>
                        </Tbody>
                    </Table>

                    <VStack
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        width={"100%"}
                        spacing={5}
                    >

                        {/* 레이블 */}

                        <Text fontSize={16} fontWeight={700} color={colors.black}>
                            ■ 회원 자격 및 이용 정보 변경 안내
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            회사는 회원의 자격이나 소속 변경에 따라 수집·활용되는 정보를 시스템에서 자동으로 정비합니다.<br />
                            기존 자격에 종속되었던 정보는 즉시 제거되거나 새로운 자격에 맞는 정보로 대체되어 관리됩니다.
                        </Text>

                        {/* 내용 */}

                        <Text fontSize={14} fontWeight={400} color={colors.black} flexWrap={"wrap"}>
                            예시: (개국약사 → 약사): 기존의 약국 관련 정보는 즉시 삭제 또는 파기되며<br />
                            이후에는 약사 개인 정보만을 기반으로 서비스 권한이 변경됩니다.
                        </Text>

                    </VStack>
           
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}